import { nextStep, prevStep } from '../../Camiones/reducers'

const initialState = {
  caladoStep: 0,
  preIngresoStep: 0,
  puestoCalado: null,
  displaySugerido: '',
  editandoCalle: false,
  nombrePuestoCalado: null,
  callesDeCalado: null,
  caladoSaveResponse: null,
  caladoShowSaveModal: false,
  dataCamionesCalados: [],
  showCargaNoAdmitible: false,
  showCaladoConfirmacionAnulacion: true,
  showConfirmacionEgreso: false,
  showPantallaConfirmacion: false,
  consultaCea: null,
  requestingConsultaCea: false,
  requestingCalificaciones: false,
  modoIngreso: 'A',
  calificaciones: [],
  url12: '',
  url34: '',
  impoblea: true,
  anulacionEgresoStep: 0,
  anulacionEgresoDeleteResponse: null,
  anulacionEgresoShowDeleteModal: false,
  ceaPendienteAutoriz: [],
  requestingCeaPendienteAutoriz: false,
  camsCalados: null,
  estadoOcupacionCallesCalado: null,
  consultaCalificacionPorCalle: null,
  pendientesSeleccionados: [],
  egresosSeleccionados: [],
  pendientesProcesados: 0,
  ceaCallesCaladoEgreso: [],
  ceaCaladoEgresoProcesados: 0,
  errorPendientesProcesados: null,
  errorCeaCaladoEgresoProcesados: null,
  estadoBarreraCalado: '',
  rechazoafip: false,
  pendientesTransacciones: [],
  lecturaAnalisisSonda: null,
  caladoImpresora: null,
  caladoImpresoraNombre: null,
  calleA: null,
  calleB: null,
  cpe: null,
  estadoCondicionSwitch: false,
  humedad: 0,
  minValorHumedad: 100,
  maxValorHumedad: 300,
  calle: '',
  siloAparte: false,
  fumigado: false,
  zarandeo: false,
  motivoDeZarandeo: null,
  pendienteAutorizar: false,
  callePreIngreso: null,
  preingresoOn: null,
  cpeEnPreingreso1: '',
  cpeEnPreingreso2: '',
  cpeEnPreingreso3: '',
  cpeEnPreingreso4: '',
  stepEgresoQR: 0,
  reloadState: false,
  fotoCea: [],
  foto: false,
  authperito: true,
  detenerConsultaFoto: false,
  showCircular: false,
  callesCaladoPorCerealHum: [],
  receiveCallesCaladoPorCerealHum: false,
  isOpenBarchar: false,
  proximoEgresoCalado: null
}

function setCalleCalado ({ puestoCalado }, state) {
  console.log('set calle', puestoCalado)
  if (puestoCalado === 'calle_1-2') {
    state.calleA = 1
    state.calleB = 2
    return true
  }
  state.calleA = 3
  state.calleB = 4
}

function setInitialDisplay ({ puestoCalado }, state) {
  console.log('init display', puestoCalado)
  if (puestoCalado === 'calle_1-2') {
    state.displaySugerido = 1
    return true
  }
  state.displaySugerido = 3
}

function setNextDisplay ({ puestoCalado }, state) {
  console.log('next display', state.puestoCalado)
  if (state.puestoCalado === 'calle_1-2') {
    state.displaySugerido = state.displaySugerido % 2 + 1
    return true
  }
  state.displaySugerido = state.displaySugerido % 2 + 3
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'OCLUTAR_PENDIENTES_STATUS':
      return {
        ...state,
        pendientesSeleccionados: [],
        pendientesProcesados: 0,
        errorPendientesProcesados: null,
        ceaPendienteAutoriz: [],
        pendientesTransacciones: []
      }
    case 'PENDIENTES_FINALIZADOS':
      return {
        ...state,
        pendientesProcesados: action.pendientesProcesados,
        errorPendientesProcesados: action.errorPendientesProcesados
      }
    case 'CARGAR_PENDIENTES': {
      return {
        ...state,
        pendientesSeleccionados: action.pendientes
      }
    }
    case 'REQUEST_PENDIENTES_AUTORIZ':
      return {
        ...state,
        pendientesProcesados: 0,
        errorPendientesProcesados: null,
        requestingCeaPendienteAutoriz: true,
        pendientesSeleccionados: []
      }
    case 'RECEIVE_PENDIENTE_AUTORIZ':
      return {
        ...state,
        requestingCeaPendienteAutoriz: false,
        ceaPendienteAutoriz: action.ceaPendienteAutoriz,
        pendientesSeleccionados: [],
        pendientesProcesados: 0,
        errorPendientesProcesados: null
      }
    case 'RECEIVE_AUTH_PERITO':
      return {
        ...state,
        authperito: (action.estado.valor === 'si')
      }
    case 'END_RECHAZO_ARCA':
      return {
        ...state,
        pendientesTransacciones: action.pendientesTransacciones
      }
    case 'REQUEST_DISPLAY_URLS':
      return {
        ...state,
        url12: '',
        url34: ''
      }
    case 'RECEIVE_DISPLAY_URLS':
      return {
        ...state,
        url12: action.url12 && action.url12['valor'],
        url34: action.url34 && action.url34['valor']
      }
    case 'UPDATE_IMPRESION_OBLEA':
      return {
        ...state,
        impoblea: action.impoblea.newValue
      }
    case 'HIDE_SAVE_CALADO_MODAL':
      return {
        ...state,
        caladoSaveResponse: null,
        caladoShowSaveModal: false
      }
    case 'UPDATE_CALADO_MODAL_ANULACION_ANALISIS':
      return {
        ...state,
        showCaladoConfirmacionAnulacion: action.show
      }
    case 'SUBMIT_CALADO_RESPONSE':
      return {
        ...state,
        caladoShowSaveModal: action.saveStatus.error,
        caladoSaveResponse: action.saveStatus
      }
    case 'NEXT_DISPLAY_SUGERIDO':
      setNextDisplay(action, state)
      return state
    case 'REQUEST_CALIFICACIONES_INGRESO':
      return {
        ...state,
        requestingCalificaciones: true,
        calificaciones: []
      }
    case 'ACTUALIZAR_CALLE_SUGERIDA':
      return {
        ...state,
        calleDeCalado: action.calleDeCalado
      }
    case 'ACTUALIZAR_DISPLAY_SUGERIDO':
      return {
        ...state,
        displaySugerido: action.display
      }
    case 'SET_CALIFICACIONES_INGRESO':
      return {
        ...state,
        requestingCalificaciones: false,
        calificaciones: action.calificaciones
      }
    case '':
      return {
        ...state,
        modoIngreso: action.modo
      }
    case 'REQUEST_CONSULTA_CEA':
      return {
        ...state,
        requestingConsultaCea: true,
        consultaCea: null
      }
    case 'RECEIVE_CONSULTA_CEA':
      return {
        ...state,
        requestingConsultaCea: false,
        consultaCea: action.consultaCea
      }
    case 'UPDATE_CONSULTA_CEA':
      return {
        ...state,
        consultaCea: action.newValue
      }
    case 'RECEIVE_CPE':
      return {
        ...state,
        cpe: action.data
      }
    case 'RECEIVE_FOTO_CEA':
      return {
        ...state,
        fotoCea: action.data
      }
    case 'RESET_FOTO_CEA':
      return {
        ...state,
        fotoCea: null
      }
    case 'SHOW_CARGA_NO_ADMITIBLE':
      return {
        ...state,
        showCargaNoAdmitible: true
      }
    case 'HIDE_CARGA_NO_ADMITIBLE':
      return {
        ...state,
        showCargaNoAdmitible: false
      }
    case 'SELECT_PUESTO_CALADO':
      setInitialDisplay(action, state)
      setCalleCalado(action, state)
      return {
        ...state,
        puestoCalado: action.puestoCalado || null,
        nombrePuestoCalado: action.nombrePuestoCalado || null
      }
    case 'RESET_PUESTO_CALADO':
      return {
        ...state,
        puestoCalado: null,
        nombrePuestoCalado: null,
        calleA: null,
        calleB: null
      }
    case 'PROCESO_CALADO_NEXT_STEP':
      return {
        ...state,
        caladoStep: nextStep({ step: state.caladoStep, max: 1 })
      }
    case 'PROCESO_CALADO_PREV_STEP':
      return {
        ...state,
        caladoStep: prevStep({ step: state.caladoStep, max: 1 })
      }
    case 'END_PROCESO_CALADO':
      return {
        ...state,
        caladoStep: 0,
        caladoSaveResponse: null,
        caladoShowSaveModal: false,
        modoIngreso: 'A'
      }
    case 'PRE_INGRESO_CALADO_NEXT_STEP':
      return {
        ...state,
        preIngresoStep: nextStep({ step: state.preIngresoStep, max: 3 })
      }

    case 'PRE_INGRESO_CALADO_PREV_STEP':
      return {
        ...state,
        preIngresoStep: prevStep({ step: state.preIngresoStep, max: 1 })
      }
    case 'END_PRE_INGRESO_CALADO':
      return {
        ...state,
        preIngresoStep: 0
      }
    case 'RECEIVE_PROXIMO_EGRESO_CALADO':
      return {
        ...state,
        proximoEgresoCalado: action.data
      }
    case 'EGRESO_QR_CALADO_NEXT_STEP':
      return {
        ...state,
        stepEgresoQR: nextStep({ step: state.stepEgresoQR, max: 1 })
      }
    case 'END_EGRESO_QR_CALADO':
      return {
        ...state,
        stepEgresoQR: 0
      }
    case 'EDICION_CALLE_CAMION_CALADO':
      return {
        ...state,
        editandoCalle: true
      }
    case 'END_EDICION_CALLE_CAMION_CALADO':
      return {
        ...state,
        editandoCalle: false
      }
    case 'RECHAZAR_ARCA':
      return {
        ...state,
        caladoShowSaveModal: (action.data.data.length > 0),
        // caladoSaveResponse: action.saveStatus.data[0].rechazarctg
        caladoSaveResponse: action.data
      }
    case 'PROCESO_CALADO_HIDE_INVALIDO':
      return {
        ...state,
        caladoShowSaveModal: false
      }
    case 'CAMIONES_CALADOS':
      return {
        ...state,
        camsCalados: action.data
      }
    case 'RECEIVE_CAMIONES_CALADOS':
      return {
        ...state,
        camionesCalados: action.data
      }
    case 'RECEIVE_CALLE_DE_CALADO':
      return {
        ...state,
        callesDeCalado: action.data
      }
    case 'ESTADO_CALLES_CALADO':
      return {
        ...state,
        estadoOcupacionCallesCalado: action.data
      }
    case 'RESET_ESTADO_CALLES_CALADO':
      return {
        ...state,
        estadoOcupacionCallesCalado: null
      }
    case 'ESTADO_CALLE_1_PREINGRESO_CALADO':
      return {
        ...state,
        cpeEnPreingreso1: action.data
      }
    case 'ESTADO_CALLE_2_PREINGRESO_CALADO':
      return {
        ...state,
        cpeEnPreingreso2: action.data
      }
    case 'ESTADO_CALLE_3_PREINGRESO_CALADO':
      return {
        ...state,
        cpeEnPreingreso3: action.data
      }
    case 'ESTADO_CALLE_4_PREINGRESO_CALADO':
      return {
        ...state,
        cpeEnPreingreso4: action.data
      }
    case 'CONSULTA_CALIFICACION_POR_CALLE_CALADO':
      return {
        ...state,
        calificacionPorCalleCalado: action.data
      }
    case 'REQUEST_CALLES_CALADO_EGRESO':
      return {
        ...state,
        ceaCaladoEgresoProcesados: 0,
        errorceaCaladoEgresoProcesados: null,
        requestingCamionesCallesCalado: true,
        egresosSeleccionados: []
      }
    case 'RECEIVE_CALLES_CALADO_EGRESO':
      return {
        ...state,
        requestingCamionesCallesCalado: false,
        ceaCallesCaladoEgreso: action.ceaCallesCaladoEgreso,
        egresoSeleccionados: [],
        ceaCaladoEgresoProcesados: 0,
        errorceaCaladoEgresoProcesados: null
      }
    case 'RECEIVE_DATA_CAMIONES_CALADOS':
      return {
        ...state,
        dataCamionesCalados: action.data
      }
    case 'CARGAR_CALLE_DE_CALADO_EGRESO':
      return {
        ...state,
        egresosSeleccionados: action.egresos
      }
    case 'ANALISIS_SONDA':
      return {
        ...state,
        lecturaAnalisisSonda: action.lecturaAnalisisSonda
      }
    case 'END_ANULACION_EGRESO':
      return {
        ...state,
        anulacionEgresoStep: 0,
        anulacionEgresoDeleteResponse: null
      }
    case 'HIDE_MODAL_ANULACION_EGRESO_STATUS':
      return {
        ...state,
        anulacionEgresoShowDeleteModal: false
      }
    case 'ANULACION_EGRESO_STATUS':
      return {
        ...state,
        anulacionEgresoDeleteResponse: action.anulacionEgresoDeleteResponse.message,
        anulacionEgresoShowDeleteModal: action.anulacionEgresoDeleteResponse.error
      }
    case 'ANULACION_EGRESO_NEXT_STEP':
      return {
        ...state,
        anulacionEgresoStep: nextStep({ step: state.anulacionEgresoStep })
      }
    case 'ANULACION_EGRESO_PREV_STEP':
      return {
        ...state,
        anulacionEgresoStep: prevStep({ step: state.anulacionEgresoStep })
      }
    case 'SELECT_PRINTER_CALADO':
      return {
        ...state,
        caladoImpresora: action.printer || null,
        caladoImpresoraNombre: action.printerName || null
      }
    case 'RESET_PRINTER_CALADO':
      return {
        ...state,
        caladoImpresora: null,
        caladoImpresoraNombre: null
      }
    case 'UPDATE_CONDICION_INGRESO':
      return {
        ...state,
        estadoCondicionSwitch: action.newState
      }
    case 'UPDATE_CALLE_PRE_INGRESO':
      return {
        ...state,
        callePreIngreso: action.calle
      }
    case 'UPDATE_HUMEDAD':
      return {
        ...state,
        humedad: action.newValue
      }
    case 'UPDATE_SILO_APARTE':
      return {
        ...state,
        siloAparte: action.newValue
      }
    case 'UPDATE_FUMIGADO':
      return {
        ...state,
        fumigado: action.newValue
      }
    case 'UPDATE_ZARANDEO':
      return {
        ...state,
        zarandeo: action.newValue
      }
    case 'UPDATE_MOTIVO_ZARANDEO':
      return {
        ...state,
        motivoDeZarandeo: action.motivo
      }
    case 'UPDATE_PENDIENTE_AUTORIZAR':
      return {
        ...state,
        pendienteAutorizar: action.newValue
      }
    case 'UPDATE_SHOW_CONFIRMACION_EGRESO':
      return {
        ...state,
        showConfirmacionEgreso: action.newValue
      }
    case 'UPDATE_VIEW_PANTALLA_CONFIRMACION':
      return {
        ...state,
        showPantallaConfirmacion: action.newValue
      }
    case 'SET_PREINGRESO_ON':
      return {
        ...state,
        preingresoOn: action.newState
      }
    case 'UPDATE_RELOAD_STATE':
      return {
        ...state,
        reloadState: action.newValue
      }
    case 'DETENER_CONSULTA_FOTO':
      return {
        ...state,
        detenerConsultaFoto: true
      }
    case 'ESTADO_BARRERA_SALIDA_ALTERNATIVA':
      return {
        ...state,
        estadoBarreraCalado: action.estado
      }
    case 'SHOW_CIRCULAR':
      return {
        ...state,
        showCircular: true
      }
    case 'HIDE_CIRCULAR':
      return {
        ...state,
        showCircular: false
      }
    case 'REQUEST_CALLES_DE_CALADO_POR_CEREAL_HUMEDAD':
      return {
        ...state,
        receiveCallesCaladoPorCerealHum: false
      }
    case 'CALLES_DE_CALADO_POR_CEREAL_HUMEDAD':
      return {
        ...state,
        callesCaladoPorCerealHum: action.data,
        receiveCallesCaladoPorCerealHum: true
      }
    case 'UPDATE_STATE_BARCHAR':
      return {
        ...state,
        isOpenBarchar: action.newValue
      }
    default:
      return state
  }
}
